import React from "react";
import ModalFooter from 'react-bootstrap/ModalFooter'

function STCModalFooter(props){

    return(
        <ModalFooter
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            as={props.as}
           
        >
            {props.children}
        </ModalFooter>
    )
}
export default STCModalFooter;